export const settingsProfileConfig = ({ client }) => ({
  HTTPMethod: "get",
  path: `/settings/${client}/profile/settings.json`,
  headers: {},
  body: {},
});
